/* SAVA Trendy — interactive layer for the dense SHEIN-style UI.
   Countdown timers only ever count down to a real, merchant-set timestamp
   (data-countdown-target, ISO8601). No fake/looping timers. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function tickCountdown(el) {
    const target = new Date(el.getAttribute('data-countdown-target')).getTime();
    const hEl = el.querySelector('[data-cd-h]');
    const mEl = el.querySelector('[data-cd-m]');
    const sEl = el.querySelector('[data-cd-s]');
    function render() {
      const diff = Math.max(0, target - Date.now());
      if (diff <= 0) { el.hidden = true; return false; }
      const totalSec = Math.floor(diff / 1000);
      const h = Math.floor(totalSec / 3600);
      const m = Math.floor((totalSec % 3600) / 60);
      const s = totalSec % 60;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      return true;
    }
    if (!render()) return;
    const timer = setInterval(() => { if (!render()) clearInterval(timer); }, 1000);
  }
  document.querySelectorAll('[data-countdown-target]').forEach(tickCountdown);

  /* Product gallery: swipe + arrow nav + slide counter */
  document.querySelectorAll('[data-pd-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-pd-track]');
    const slides = track ? track.children.length : 0;
    const counter = gallery.querySelector('[data-pd-counter]');
    let index = 0;
    function go(i) {
      index = (i + slides) % slides;
      track.style.transform = `translateX(-${index * 100}%)`;
      if (counter) counter.textContent = index + 1;
    }
    gallery.querySelectorAll('[data-pd-prev]').forEach((b) => b.addEventListener('click', () => go(index - 1)));
    gallery.querySelectorAll('[data-pd-next]').forEach((b) => b.addEventListener('click', () => go(index + 1)));
    let startX = 0;
    track && track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track && track.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      if (startX - endX > 40) go(index + 1);
      if (endX - startX > 40) go(index - 1);
    }, { passive: true });
  });

  /* Wishlist heart toggle — visual only, persisted per-browser via localStorage */
  function wishlistKey(id) { return 'sava_wishlist_' + id; }
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    const id = btn.getAttribute('data-wishlist-toggle');
    const isOn = btn.classList.toggle('is-active');
    document.querySelectorAll(`[data-wishlist-toggle="${id}"]`).forEach((b) => b.classList.toggle('is-active', isOn));
    try { localStorage.setItem(wishlistKey(id), isOn ? '1' : '0'); } catch (e) {}
  });
  document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
    try {
      const on = localStorage.getItem(wishlistKey(btn.getAttribute('data-wishlist-toggle'))) === '1';
      if (on) btn.classList.add('is-active');
    } catch (e) {}
  });

  /* Share button: native share sheet, falls back to copy-link */
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-share]');
    if (!btn) return;
    const url = btn.getAttribute('data-share') || window.location.href;
    if (navigator.share) {
      navigator.share({ url, title: document.title }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(() => {
        btn.classList.add('is-copied');
        setTimeout(() => btn.classList.remove('is-copied'), 1500);
      }).catch(() => {});
    }
  });

  /* Product detail: color + size swatch selection, synced to real variants */
  document.querySelectorAll('[data-pd-form]').forEach((form) => {
    const variantData = form.querySelector('[data-pd-variants]');
    if (!variantData) return;
    const variants = JSON.parse(variantData.textContent || '[]');
    const optionState = {};
    function findVariant() {
      const values = Object.values(optionState);
      return variants.find((v) => v.options.every((val, i) => val === values[i]));
    }
    function applyVariant(variant) {
      const hiddenInput = form.querySelector('[data-pd-variant-id]');
      const ctas = form.querySelectorAll('[data-pd-cta]');
      const priceNow = form.querySelector('[data-pd-price-now]');
      const priceWas = form.querySelector('[data-pd-price-was]');
      const stockNote = form.querySelector('[data-pd-stock-note]');
      if (!variant) {
        ctas.forEach((b) => { b.setAttribute('disabled', 'disabled'); });
        if (stockNote) stockNote.textContent = 'Select options';
        return;
      }
      if (hiddenInput) hiddenInput.value = variant.id;
      ctas.forEach((b) => { if (variant.available) b.removeAttribute('disabled'); else b.setAttribute('disabled', 'disabled'); });
      const fmt = (cents) => '$' + (cents / 100).toFixed(2);
      if (priceNow) priceNow.textContent = fmt(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = fmt(variant.compare_at_price);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (stockNote) {
        if (!variant.available) {
          stockNote.textContent = 'Sold out';
          stockNote.hidden = false;
        }
        else if (variant.inventory_management && typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
          stockNote.textContent = `Only ${variant.inventory_quantity} left`;
          stockNote.hidden = false;
        } else {
          stockNote.hidden = true;
        }
      }
    }

    form.querySelectorAll('[data-pd-swatch]').forEach((swatch) => {
      const posAttr = swatch.closest('[data-pd-option-index]');
      if (!posAttr) return;
      const idx = parseInt(posAttr.getAttribute('data-pd-option-index'), 10);
      if (swatch.classList.contains('is-selected') || swatch.classList.contains('is-preselected')) {
        optionState[idx] = swatch.getAttribute('data-pd-swatch');
      }
    });

    form.addEventListener('click', function (event) {
      const swatch = event.target.closest('[data-pd-swatch]');
      if (!swatch) return;
      const group = swatch.closest('[data-pd-option-index]');
      if (!group) return;
      const idx = parseInt(group.getAttribute('data-pd-option-index'), 10);
      optionState[idx] = swatch.getAttribute('data-pd-swatch');
      group.querySelectorAll('[data-pd-swatch]').forEach((el) => el.classList.remove('is-selected'));
      swatch.classList.add('is-selected');
      const labelTarget = group.getAttribute('data-pd-label-target');
      if (labelTarget) {
        const labelEl = form.querySelector(labelTarget);
        if (labelEl) labelEl.textContent = swatch.getAttribute('data-pd-swatch-label') || optionState[idx];
      }
      applyVariant(findVariant());
    });

    applyVariant(findVariant());
  });

  /* Discount code: redeem via Shopify's native /discount/{code} redirect — never pre-applied */
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-discount-form]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('[data-discount-input]');
    const code = (input && input.value || '').trim();
    if (!code) return;
    const base = form.getAttribute('data-discount-base');
    window.location.href = base + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  });

  /* Cart line-item quantity stepper — real AJAX update via /cart/change.js */
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-qty-step]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty-stepper]');
    const line = wrap.getAttribute('data-line-key');
    const display = wrap.querySelector('[data-qty-value]');
    const delta = parseInt(btn.getAttribute('data-qty-step'), 10);
    let next = parseInt(display.textContent, 10) + delta;
    if (next < 0) next = 0;
    wrap.querySelectorAll('button').forEach((b) => (b.disabled = true));
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity: next }),
    })
      .then((r) => r.json())
      .then(() => { window.location.reload(); })
      .catch(() => { wrap.querySelectorAll('button').forEach((b) => (b.disabled = false)); });
  });

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-cart-remove]');
    if (!btn) return;
    event.preventDefault();
    const line = btn.getAttribute('data-cart-remove');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity: 0 }),
    }).then(() => window.location.reload());
  });
})();
